// Shared runtime context for the split behaviour modules.
//
// hiveMind.adopt() injects the orchestrator by assigning `behaviors.hm = hm` on
// the assembled object (behaviors.js). Per-behaviour modules that need hm (e.g.
// passwordMeter) read it from here instead of importing the assembled object —
// which would create an import cycle. behaviors.js defines `hm` as an accessor
// that reads/writes this holder, so the adopt assignment lands here.
const context = { hm: null };

export default context;
